const body = document.body;
const header = document.querySelector("header");
const main = document.querySelector("main");
const headerHeight = document.querySelector("header").offsetHeight;
const headerMenus = document.querySelector(".header__menus");
const headerMenusNav = document.querySelector(".header__menus nav");
const burgerBtn = document.querySelector(".hamburger");

window.addEventListener('load', function () {

  // -- functions --
  const closeMainMenu = function(){
    body.classList.remove('mainMenuOpen', 'overflow-hidden');
    headerMenus.classList.remove('!translate-x-0', 'sm:!translate-y-0');
    burgerBtn.classList.remove('is-active');
  };

  // -- animation header --
  if (body.classList.contains('type--home')) {
    setTimeout(function(){
      header.classList.remove('-translate-y-full');
      header.classList.add('translate-y-0');
    },1200);
  }

  // -- close main menu when click outside header --
  window.addEventListener('click', function(e){   
    if (!header.contains(e.target)){
      closeMainMenu();
    }
  });

  // -- open/close main menu --
  burgerBtn.addEventListener('click', function (e) {
    burgerBtn.classList.toggle('is-active');
    body.classList.toggle('mainMenuOpen');
    body.classList.toggle('overflow-hidden');
    headerMenus.classList.toggle('!translate-x-0');
    headerMenus.classList.toggle('sm:!translate-y-0');
    headerMenusNav.classList.toggle('animate-fadeIn');
  });
});

main.style.top = headerHeight + "px";
let lastScroll = 0;
window.addEventListener("scroll", () => {
  let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
  // -- show/hide main menu --
  if (currentScroll - lastScroll > 0) {
    header.classList.add("scroll-down");
    header.classList.remove("scroll-up");
  } else {
    header.classList.add("scroll-up");
    header.classList.remove("scroll-down");
  }
  lastScroll =  currentScroll <= 0 ? 0 : currentScroll;
  // -- update bg-color --
  const color = (body.classList.contains('type--home')) ? 'brand' : 'white';
  if (currentScroll >= headerHeight) {
    header.classList.add("bg-"+color);
  } else {
    header.classList.remove("bg-"+color);
  }
});